module.exports = __webpack_public_path__ + "media/images/amenities_icons/img_lounge-1a053d5806c773acefcb5c0c1b887e58.svg";